import React, { PureComponent } from 'react';
import Modal from '@material-ui/core/Modal';
import Backdrop from '@material-ui/core/Backdrop';
import Fade from '@material-ui/core/Fade';
import './endStock.scss'

class CSVErrorTable extends PureComponent {

    handleClose = () => {
        this.props.flagHandle()
    };

    render() {
        return (
            <div className='endstock-table' >
                < Modal
                    className='modal'
                    open={this.props.isOpen}
                    onClose={this.handleClose}
                    closeAfterTransition
                    BackdropComponent={Backdrop}
                    BackdropProps={{
                        timeout: 500,
                    }}
                >
                    <Fade in={this.props.isOpen} >
                        <div className='csv-error-table-container'>
                            <p className='csv-error-table-heading'>CSV Errors Table</p>
                            <table className='csv-error-table'>
                                <thead>
                                    <tr>
                                        <th className='csv-error-table-header-cell'>
                                            Project Code
                                        </th>
                                        <th className='csv-error-table-header-cell'>
                                            Activity Code
                                        </th>
                                        <th className='csv-error-table-header-cell'>
                                            MSKU Code
                                        </th>
                                        <th className='csv-error-table-header-cell'>
                                            Baseline
                                        </th>
                                        <th className='csv-error-table-header-cell'>
                                            Incremental AWS
                                        </th>
                                        <th className='csv-error-table-header-cell'>
                                            Post AWS
                                        </th>
                                        <th className='csv-error-table-header-cell'>
                                            Norm
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        this.props.data && this.props.data.map((item,ind)=>(
                                            <tr key={item.msku_code+ind}>
                                                <td className={`csv-error-table-cell ${item.project_code ? 'csv-normal-cell' : 'csv-error-cell'}`}>{item.project_code}</td>
                                                <td className={`csv-error-table-cell ${item.activity_code ? 'csv-normal-cell' : 'csv-error-cell'}`}>{item.activity_code}</td>
                                                <td className={`csv-error-table-cell ${item.msku_code ? 'csv-normal-cell' : 'csv-error-cell'}`}>{item.msku_code}</td>
                                                <td className={`csv-error-table-cell ${(isNaN(item.baseline) || item.baseline <= 0) ? 'csv-error-cell' : 'csv-normal-cell'}`}>{item.baseline}</td>
                                                <td className={`csv-error-table-cell ${(isNaN(item.incremental_aws) || item.incremental_aws <= 0) ? 'csv-error-cell' : 'csv-normal-cell'}`}>{item.incremental_aws}</td>
                                                <td className={`csv-error-table-cell ${(isNaN(item.post_aws) || item.post_aws <= 0) ? 'csv-error-cell' : 'csv-normal-cell'}`}>{item.post_aws}</td>
                                                <td className={`csv-error-table-cell ${(isNaN(item.norm) || item.norm <= 0) ? 'csv-error-cell' : 'csv-normal-cell'}`}>{item.norm}</td>
                                            </tr>
                                        ))
                                    }
                                </tbody>
                            </table>
                        </div>
                    </Fade>
                </Modal >
            </div >
        )
    }
}

export default CSVErrorTable;
